import React from 'react'
import Custom from './animation';
function Hero(){
	return(
	 <><Custom /></>
 )}
export default Hero